import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version — vehicle-handling
export const vehicleHandlingMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-vh-1',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-1-vehicle-skidding.jpg',
    text: {
      en: 'What should you do if your vehicle starts to skid?',
      nl: 'Wat moet u doen als uw voertuig in een slip raakt?',
      ar: 'ماذا تفعل إذا بدأت مركبتك بالانزلاق (الانحراف)؟',
    },
    options: [
      {
        id: 'q-vh-1o1',
        text: {
          en: 'Brake hard',
          nl: 'Hard remmen',
          ar: 'الكبح بقوة',
        },
      },
      {
        id: 'q-vh-1o2',
        text: {
          en: 'Ease off the accelerator and steer in the direction you want to go; do not brake sharply',
          nl: 'Het gas loslaten en sturen in de richting waarin u wilt rijden; niet scherp remmen',
          ar: 'خفف الضغط على دواسة الوقود ووجه المقود نحو الاتجاه الذي تريد الذهاب إليه؛ لا تكبح بشدة',
        },
      },
      {
        id: 'q-vh-1o3',
        text: {
          en: 'Accelerate to regain grip',
          nl: 'Versnellen om grip terug te krijgen',
          ar: 'زيادة السرعة لاستعادة الالتصاق',
        },
      },
    ],
    correctAnswerId: 'q-vh-1o2',
    explanation: {
      en: 'Ease off the accelerator. Steer in the direction you want the front of the vehicle to go. Avoid braking hard; it can make the skid worse.',
      nl: 'Laat het gas los. Stuur in de richting waarin u de voorkant van het voertuig wilt laten gaan. Vermijd hard remmen; dat kan de slip verergeren.',
      ar: 'خفف الوقود. وجه المقود نحو الاتجاه الذي تريد أن يتجه مقدمة المركبة إليه. تجنب الكبح الشديد؛ فقد يزيد الانزلاق سوءا.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-2',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-2-aquaplaning.jpg',
    text: {
      en: 'What is "aquaplaning"?',
      nl: "Wat is 'aquaplaning'?",
      ar: 'ما هو «الانزلاق المائي» (الطفو على الماء)؟',
    },
    options: [
      {
        id: 'q-vh-2o1',
        text: {
          en: 'Driving through a car wash',
          nl: 'Door een wasstraat rijden',
          ar: 'المرور بمغسلة سيارات',
        },
      },
      {
        id: 'q-vh-2o2',
        text: {
          en: 'When the tyres lose grip on a wet road and the vehicle slides on a film of water',
          nl: 'Wanneer de banden grip verliezen op nat wegdek en het voertuig op een waterfilm glijdt',
          ar: 'عندما تفقد الإطارات الالتصاق على طريق مبلل وتنزلق المركبة على طبقة من الماء',
        },
      },
      {
        id: 'q-vh-2o3',
        text: {
          en: 'Using windscreen washer fluid',
          nl: 'Ruitenwisservloeistof gebruiken',
          ar: 'استخدام سائل مساحات الزجاج',
        },
      },
    ],
    correctAnswerId: 'q-vh-2o2',
    explanation: {
      en: 'Aquaplaning is when the tyres lift off the road surface on a layer of water and you lose steering and braking. Ease off the accelerator and do not brake hard.',
      nl: 'Aquaplaning is wanneer de banden op een waterlaag van het wegdek loskomen en u stuur- en remverlies heeft. Laat het gas los en rem niet hard.',
      ar: 'الانزلاق المائي يحدث عندما ترتفع الإطارات عن سطح الطريق فوق طبقة ماء فتفقد التوجيه والكبح. خفف الوقود ولا تكبح بقوة.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-3',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-3-brake-failure.jpg',
    text: {
      en: 'What should you do if your brakes fail?',
      nl: 'Wat moet u doen als uw remmen uitvallen?',
      ar: 'ماذا تفعل إذا تعطلت الفرامل؟',
    },
    options: [
      {
        id: 'q-vh-3o1',
        text: {
          en: 'Switch off the engine immediately',
          nl: 'De motor onmiddellijk uitzetten',
          ar: 'إطفاء المحرك فورا',
        },
      },
      {
        id: 'q-vh-3o2',
        text: {
          en: 'Use the parking brake gradually; change to a lower gear; use engine braking; warn others',
          nl: 'De handrem geleidelijk gebruiken; naar een lagere versnelling schakelen; motorrem gebruiken; anderen waarschuwen',
          ar: 'استخدام فرملة الانتظار تدريجيا؛ النزول إلى ترس أدنى؛ استخدام كبح المحرك؛ تحذير الآخرين',
        },
      },
      {
        id: 'q-vh-3o3',
        text: {
          en: 'Accelerate to get off the road',
          nl: 'Versnellen om van de weg af te komen',
          ar: 'زيادة السرعة للخروج من الطريق',
        },
      },
    ],
    correctAnswerId: 'q-vh-3o2',
    explanation: {
      en: 'Apply the parking brake gradually (not suddenly). Change to a lower gear to use engine braking. Use hazard lights and try to steer to a safe place.',
      nl: 'Gebruik de handrem geleidelijk (niet plotseling). Schakel naar een lagere versnelling voor motorrem. Gebruik waarschuwingslichten en stuur naar een veilige plek.',
      ar: 'اضغط فرملة الانتظار تدريجيا (وليس فجأة). انزل إلى ترس أدنى لاستخدام كبح المحرك. استخدم أضواء التحذير وحاول التوجيه إلى مكان آمن.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-4',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-4-ice-snow-driving.jpg',
    text: {
      en: 'When driving on ice or snow, what should you do?',
      nl: 'Wat moet u doen bij rijden op ijs of sneeuw?',
      ar: 'عند القيادة على الجليد أو الثلج، ماذا تفعل؟',
    },
    options: [
      {
        id: 'q-vh-4o1',
        text: {
          en: 'Drive at normal speed',
          nl: 'Met normale snelheid rijden',
          ar: 'القيادة بالسرعة المعتادة',
        },
      },
      {
        id: 'q-vh-4o2',
        text: {
          en: 'Drive slowly and smoothly; avoid sudden braking, acceleration, or steering',
          nl: 'Langzaam en vloeiend rijden; plotseling remmen, accelereren of sturen vermijden',
          ar: 'القيادة ببطء وانسيابية؛ تجنب الكبح أو التسارع أو التوجيه المفاجئ',
        },
      },
      {
        id: 'q-vh-4o3',
        text: {
          en: 'Use the highest gear possible',
          nl: 'De hoogst mogelijke versnelling gebruiken',
          ar: 'استخدام أعلى ترس ممكن',
        },
      },
    ],
    correctAnswerId: 'q-vh-4o2',
    explanation: {
      en: 'On ice or snow, drive slowly and smoothly. Avoid sudden braking, acceleration, or steering. Use a higher gear to reduce wheel spin.',
      nl: 'Rijd op ijs of sneeuw langzaam en vloeiend. Vermijd plotseling remmen, accelereren of sturen. Gebruik een hogere versnelling om doorslijpen te beperken.',
      ar: 'على الجليد أو الثلج قد ببطء وبسلاسة. تجنب الكبح أو التسارع أو التوجيه المفاجئ. استخدم ترسا أعلى لتقليل دوران العجلات بلا التصاق.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-5',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-5-heavy-steering.jpg',
    text: {
      en: 'What should you do if your steering suddenly becomes very heavy?',
      nl: 'Wat moet u doen als het stuur plotseling zeer zwaar wordt?',
      ar: 'ماذا تفعل إذا ثقل المقود فجأة؟',
    },
    options: [
      {
        id: 'q-vh-5o1',
        text: {
          en: 'Speed up to make steering easier',
          nl: 'Versnellen om sturen gemakkelijker te maken',
          ar: 'زيادة السرعة لتسهيل التوجيه',
        },
      },
      {
        id: 'q-vh-5o2',
        text: {
          en: 'Slow down and stop safely; you may have a puncture or power steering failure',
          nl: 'Vertragen en veilig stoppen; u heeft mogelijk een lekke band of stuurbekrachtigingsstoring',
          ar: 'الإبطاء والتوقف بأمان؛ قد يكون لديك ثقب في الإطار أو عطل في نظام التوجيه المعزز',
        },
      },
      {
        id: 'q-vh-5o3',
        text: {
          en: 'Brake hard',
          nl: 'Hard remmen',
          ar: 'الكبح بقوة',
        },
      },
    ],
    correctAnswerId: 'q-vh-5o2',
    explanation: {
      en: 'Heavy steering can mean a puncture (front tyre) or power steering failure. Slow down and stop in a safe place. Check tyres and fluid.',
      nl: 'Zwaar stuur kan wijzen op een lekke band (voorband) of een storing van de stuurbekrachtiging. Vertraag en stop op een veilige plek. Controleer banden en vloeistof.',
      ar: 'ثقل المقود قد يعني ثقبا في الإطار (الأمامي) أو عطلا في التوجيه المعزز. أبطئ وتوقف في مكان آمن. افحص الإطارات والسوائل.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-6',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-6-tire-blowout.jpg',
    text: {
      en: 'What should you do if a tyre blows out at speed?',
      nl: 'Wat moet u doen als een band op snelheid klapt?',
      ar: 'ماذا تفعل إذا انفجر إطار وأنت تسير بسرعة؟',
    },
    options: [
      {
        id: 'q-vh-6o1',
        text: {
          en: 'Brake hard and steer to the left',
          nl: 'Hard remmen en naar links sturen',
          ar: 'الكبح بقوة والتوجيه يسارا',
        },
      },
      {
        id: 'q-vh-6o2',
        text: {
          en: 'Hold the steering wheel firmly; ease off the accelerator; brake gently only when speed has dropped',
          nl: 'Het stuur stevig vasthouden; het gas loslaten; pas zacht remmen wanneer de snelheid is gedaald',
          ar: 'إمساك المقود بثبات؛ خفف الوقود؛ الكبح برفق فقط بعد انخفاض السرعة',
        },
      },
      {
        id: 'q-vh-6o3',
        text: {
          en: 'Accelerate to balance the car',
          nl: 'Versnellen om de auto in balans te brengen',
          ar: 'زيادة السرعة لموازنة السيارة',
        },
      },
    ],
    correctAnswerId: 'q-vh-6o2',
    explanation: {
      en: 'Hold the steering wheel firmly. Ease off the accelerator. Do not brake sharply; brake gently when the vehicle has slowed. Pull off the road when safe.',
      nl: 'Houd het stuur stevig vast. Laat het gas los. Rem niet scherp; rem zacht wanneer het voertuig is vertraagd. Verlaat de weg wanneer het veilig is.',
      ar: 'أمسك المقود بثبات. خفف الوقود. لا تكبح بشدة؛ كبح برفق بعد أن تبطئ المركبة. انسحب إلى جانب الطريق عند الأمان.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-7',
    text: {
      en: 'What is "engine braking"?',
      nl: "Wat is 'motorremmen'?",
      ar: 'ما هو «كبح المحرك»؟',
    },
    options: [
      {
        id: 'q-vh-7o1',
        text: {
          en: 'When the engine stops',
          nl: 'Wanneer de motor stopt',
          ar: 'عند توقف المحرك',
        },
      },
      {
        id: 'q-vh-7o2',
        text: {
          en: 'Using a lower gear to slow the vehicle without using the brakes as much',
          nl: 'Een lagere versnelling gebruiken om het voertuig te vertragen zonder zoveel te remmen',
          ar: 'استخدام ترس أدنى لإبطاء المركبة دون الاعتماد على الفرامل بقدر كبير',
        },
      },
      {
        id: 'q-vh-7o3',
        text: {
          en: 'Putting the car in neutral',
          nl: 'De auto in vrij zetten',
          ar: 'وضع السيارة على الوضع المحايد',
        },
      },
    ],
    correctAnswerId: 'q-vh-7o2',
    explanation: {
      en: 'Engine braking means changing to a lower gear so the engine helps slow the vehicle. It reduces wear on brakes and helps control speed on downhill or slippery roads.',
      nl: 'Motorremmen betekent naar een lagere versnelling schakelen zodat de motor het voertuig helpt vertragen. Het vermindert slijtage van de remmen en helpt de snelheid te beheersen op afdalingen of glad wegdek.',
      ar: 'كبح المحرك يعني النزول إلى ترس أدنى ليساعد المحرك على إبطاء المركبة. يقلل تآكل الفرامل ويساعد على ضبط السرعة في المنحدرات أو الطرق الزلقة.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-8',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-8-stuck-accelerator.jpg',
    text: {
      en: 'What should you do if your accelerator sticks?',
      nl: 'Wat moet u doen als het gaspedaal blijft hangen?',
      ar: 'ماذا تفعل إذا علقت دواسة الوقود؟',
    },
    options: [
      {
        id: 'q-vh-8o1',
        text: {
          en: 'Switch off the engine immediately',
          nl: 'De motor onmiddellijk uitzetten',
          ar: 'إطفاء المحرك فورا',
        },
      },
      {
        id: 'q-vh-8o2',
        text: {
          en: 'Try to free it with your foot; if not, shift to neutral and brake; pull off the road and switch off',
          nl: 'Proberen het met uw voet los te maken; zo niet, in vrij schakelen en remmen; de weg verlaten en uitzetten',
          ar: 'محاولة تحريرها بالقدم؛ إن لم تنجح، ضع الوضع المحايد وكبح؛ الانسحاب إلى جانب الطريق ثم الإطفاء',
        },
      },
      {
        id: 'q-vh-8o3',
        text: {
          en: 'Brake hard only',
          nl: 'Alleen hard remmen',
          ar: 'الكبح بقوة فقط',
        },
      },
    ],
    correctAnswerId: 'q-vh-8o2',
    explanation: {
      en: 'Try to free the pedal. If it stays stuck, shift to neutral, brake, and pull off the road. Switch off the engine when safe.',
      nl: 'Probeer het pedaal los te maken. Blijft het hangen, schakel in vrij, rem en verlaat de weg. Zet de motor uit wanneer het veilig is.',
      ar: 'حاول تحرير الدواسة. إذا بقيت عالقة، ضع الوضع المحايد وكبح وانسحب إلى جانب الطريق. أطفئ المحرك عند الأمان.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-9',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-9-downhill-descent.jpg',
    text: {
      en: 'When driving downhill for a long time, what should you do?',
      nl: 'Wat moet u doen bij langdurig rijden bergaf?',
      ar: 'عند القيادة منحدرا لفترة طويلة، ماذا تفعل؟',
    },
    options: [
      {
        id: 'q-vh-9o1',
        text: {
          en: 'Use the brakes continuously',
          nl: 'Continu remmen',
          ar: 'استخدام الفرامل باستمرار',
        },
      },
      {
        id: 'q-vh-9o2',
        text: {
          en: 'Use a lower gear and brake in short bursts; avoid riding the brakes',
          nl: 'Een lagere versnelling gebruiken en in korte stoten remmen; voortdurend op de rem staan vermijden',
          ar: 'استخدام ترس أدنى والكبح على دفعات قصيرة؛ تجنب الضغط المستمر على الفرامل',
        },
      },
      {
        id: 'q-vh-9o3',
        text: {
          en: 'Put the car in neutral',
          nl: 'De auto in vrij zetten',
          ar: 'وضع السيارة على الوضع المحايد',
        },
      },
    ],
    correctAnswerId: 'q-vh-9o2',
    explanation: {
      en: 'Use a lower gear for engine braking. Brake in short bursts. Avoid holding the brakes on (brake fade and overheating).',
      nl: 'Gebruik een lagere versnelling voor motorrem. Rem in korte stoten. Vermijd langdurig remmen (remvervaging en oververhitting).',
      ar: 'استخدم ترسا أدنى لكبح المحرك. كبح على دفعات. تجنب الضغط المستمر على الفرامل (ضعف الفرامل والإفراط في الحرارة).',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-10',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-10-deep-water-crossing.jpg',
    text: {
      en: 'What should you do if you drive through deep water?',
      nl: 'Wat moet u doen als u door diep water rijdt?',
      ar: 'ماذا تفعل إذا اجتزت ماء عميقا؟',
    },
    options: [
      {
        id: 'q-vh-10o1',
        text: {
          en: 'Drive as fast as possible',
          nl: 'Zo snel mogelijk rijden',
          ar: 'القيادة بأقصى سرعة ممكنة',
        },
      },
      {
        id: 'q-vh-10o2',
        text: {
          en: 'Drive slowly and steadily; test brakes afterwards',
          nl: 'Langzaam en gelijkmatig rijden; daarna de remmen testen',
          ar: 'القيادة ببطء وبثبات؛ اختبار الفرامل بعد ذلك',
        },
      },
      {
        id: 'q-vh-10o3',
        text: {
          en: 'Use the handbrake to dry the brakes',
          nl: 'De handrem gebruiken om de remmen te laten opdrogen',
          ar: 'استخدام فرملة اليد لتجفيف الفرامل',
        },
      },
    ],
    correctAnswerId: 'q-vh-10o2',
    explanation: {
      en: 'Drive slowly and steadily through deep water. After leaving the water, test your brakes; they may be less effective until dry.',
      nl: 'Rijd langzaam en gelijkmatig door diep water. Test na het water de remmen; ze kunnen minder effectief zijn tot ze droog zijn.',
      ar: 'قد ببطء وبثبات عبر الماء العميق. بعد الخروج، اختبر الفرامل؛ قد تكون أقل فعالية حتى تجف.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-11',
    text: {
      en: 'What is "brake fade"?',
      nl: "Wat is 'remvervaging'?",
      ar: 'ما هو «ضعف الفرامل»؟',
    },
    options: [
      {
        id: 'q-vh-11o1',
        text: {
          en: 'When the brake pedal fades in colour',
          nl: 'Wanneer het rempedaal van kleur vervaagt',
          ar: 'عندما يبهت لون دواسة الفرامل',
        },
      },
      {
        id: 'q-vh-11o2',
        text: {
          en: 'When brakes overheat and become less effective after prolonged or heavy use',
          nl: 'Wanneer remmen oververhitten en minder effectief worden na langdurig of zwaar gebruik',
          ar: 'عندما ترتفع حرارة الفرامل فتقل فعاليتها بعد استخدام مطول أو شديد',
        },
      },
      {
        id: 'q-vh-11o3',
        text: {
          en: 'When the brakes make no noise',
          nl: 'Wanneer de remmen geen geluid maken',
          ar: 'عندما لا تصدر الفرامل صوتا',
        },
      },
    ],
    correctAnswerId: 'q-vh-11o2',
    explanation: {
      en: 'Brake fade is when brakes overheat (e.g. long downhill braking) and lose effectiveness. Use a lower gear and brake in short bursts to avoid it.',
      nl: 'Remvervaging is wanneer remmen oververhitten (bijv. lang remmen bergaf) en effectiviteit verliezen. Gebruik een lagere versnelling en rem in korte stoten om dit te voorkomen.',
      ar: 'ضعف الفرامل يحدث عند ارتفاع حرارتها (مثل الكبح الطويل في المنحدر) وفقدان الفعالية. استخدم ترسا أدنى وكبحا على دفعات لتجنب ذلك.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-12',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-12-vehicle-fire.jpg',
    text: {
      en: 'What should you do if your vehicle catches fire?',
      nl: 'Wat moet u doen als uw voertuig vlam vat?',
      ar: 'ماذا تفعل إذا اشتعلت مركبتك؟',
    },
    options: [
      {
        id: 'q-vh-12o1',
        text: {
          en: 'Open the bonnet and pour water',
          nl: 'De motorkap openen en water gieten',
          ar: 'فتح غطاء المحرك وسكب الماء',
        },
      },
      {
        id: 'q-vh-12o2',
        text: {
          en: 'Stop safely; get everyone out; call fire service; do not open the bonnet if you suspect engine fire',
          nl: 'Veilig stoppen; iedereen eruit; brandweer bellen; motorkap niet openen bij vermoeden van motorbrand',
          ar: 'التوقف بأمان؛ إخراج الجميع؛ الاتصال بخدمة الإطفاء؛ عدم فتح غطاء المحرك إذا اشتبهت بحريق في المحرك',
        },
      },
      {
        id: 'q-vh-12o3',
        text: {
          en: 'Drive to the nearest garage',
          nl: 'Naar de dichtstbijzijnde garage rijden',
          ar: 'القيادة إلى أقرب ورشة',
        },
      },
    ],
    correctAnswerId: 'q-vh-12o2',
    explanation: {
      en: 'Stop in a safe place. Get everyone out and away from the vehicle. Call the fire service. Do not open the bonnet if there is an engine fire; it can spread.',
      nl: 'Stop op een veilige plek. Laat iedereen uitstappen en weg bij het voertuig. Bel de brandweer. Open de motorkap niet bij motorbrand; het vuur kan zich verspreiden.',
      ar: 'توقف في مكان آمن. أخرج الجميع وباعدهم عن المركبة. اتصل بخدمة الإطفاء. لا تفتح غطاء المحرك عند حريق في المحرك؛ قد ينتشر اللهب.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-13',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-13-bonnet-flying.jpg',
    text: {
      en: 'What should you do if the bonnet flies up while you are driving?',
      nl: 'Wat moet u doen als de motorkap omhoog klapt tijdens het rijden?',
      ar: 'ماذا تفعل إذا انفتح غطاء المحرك أثناء القيادة؟',
    },
    options: [
      {
        id: 'q-vh-13o1',
        text: {
          en: 'Speed up to push it down',
          nl: 'Versnellen om hem omlaag te drukken',
          ar: 'زيادة السرعة لدفعه للأسفل',
        },
      },
      {
        id: 'q-vh-13o2',
        text: {
          en: 'Ease off; look through the gap or out of the side window; signal and pull off the road safely',
          nl: 'Gas loslaten; door de spleet of via het zijruit kijken; richting aangeven en veilig de weg verlaten',
          ar: 'خفف الوقود؛ انظر من الفتحة تحت الغطاء أو من النافذة الجانبية؛ أشر وانسحب إلى جانب الطريق بأمان',
        },
      },
      {
        id: 'q-vh-13o3',
        text: {
          en: 'Brake hard immediately',
          nl: 'Onmiddellijk hard remmen',
          ar: 'الكبح بقوة فورا',
        },
      },
    ],
    correctAnswerId: 'q-vh-13o2',
    explanation: {
      en: 'Ease off the accelerator. Look through the gap under the bonnet or through the side window. Signal and pull off the road when safe.',
      nl: 'Laat het gas los. Kijk door de spleet onder de motorkap of via het zijruit. Geef richting aan en verlaat de weg wanneer het veilig is.',
      ar: 'خفف الوقود. انظر من الفتحة تحت الغطاء أو من النافذة الجانبية. أشر وانسحب عند الأمان.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-14',
    text: {
      en: 'When should you use the parking brake (handbrake)?',
      nl: 'Wanneer moet u de handrem gebruiken?',
      ar: 'متى يجب استخدام فرملة الانتظار (الفرامل اليدوية)؟',
    },
    options: [
      {
        id: 'q-vh-14o1',
        text: {
          en: 'Only when parking on a hill',
          nl: 'Alleen bij parkeren op een helling',
          ar: 'فقط عند الوقوف على منحدر',
        },
      },
      {
        id: 'q-vh-14o2',
        text: {
          en: 'When parking; also in an emergency if the foot brake fails',
          nl: 'Bij parkeren; ook in noodgevallen als de voetrem uitvalt',
          ar: 'عند الوقوف؛ وكذلك في الطوارئ إذا تعطلت فرملة القدم',
        },
      },
      {
        id: 'q-vh-14o3',
        text: {
          en: 'Never on a modern car',
          nl: 'Nooit op een moderne auto',
          ar: 'أبدا في سيارة حديثة',
        },
      },
    ],
    correctAnswerId: 'q-vh-14o2',
    explanation: {
      en: 'Use the parking brake when you park. You can also use it in an emergency if the foot brake fails (apply gradually).',
      nl: 'Gebruik de handrem wanneer u parkeert. U kunt hem ook in noodgevallen gebruiken als de voetrem uitvalt (geleidelijk aanleggen).',
      ar: 'استخدم فرملة الانتظار عند الوقوف. يمكنك استخدامها في الطوارئ إذا تعطلت فرملة القدم (بشكل تدريجي).',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-15',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-15-low-oil-pressure.jpg',
    text: {
      en: 'What should you do if you are driving and see a warning light for low oil pressure?',
      nl: 'Wat moet u doen als u tijdens het rijden een waarschuwingslampje voor lage oliedruk ziet?',
      ar: 'ماذا تفعل إذا رأيت أثناء القيادة تحذير ضغط الزيت المنخفض؟',
    },
    options: [
      {
        id: 'q-vh-15o1',
        text: {
          en: 'Continue to your destination',
          nl: 'Verder rijden naar uw bestemming',
          ar: 'مواصلة الطريق إلى وجهتك',
        },
      },
      {
        id: 'q-vh-15o2',
        text: {
          en: 'Stop as soon as safe; switch off the engine; do not drive until checked',
          nl: 'Zo snel mogelijk veilig stoppen; motor uitzetten; niet verder rijden tot controle',
          ar: 'التوقف عند أول أمان؛ إطفاء المحرك؛ عدم القيادة حتى الفحص',
        },
      },
      {
        id: 'q-vh-15o3',
        text: {
          en: 'Add water',
          nl: 'Water bijvullen',
          ar: 'إضافة ماء',
        },
      },
    ],
    correctAnswerId: 'q-vh-15o2',
    explanation: {
      en: 'Low oil pressure can cause serious engine damage. Stop as soon as it is safe, switch off the engine, and have the vehicle checked.',
      nl: 'Lage oliedruk kan ernstige motorschade veroorzaken. Stop zodra het veilig is, zet de motor uit en laat het voertuig controleren.',
      ar: 'ضغط الزيت المنخفض قد يلحق ضررا جسيما بالمحرك. توقف عند أمان، أطفئ المحرك، وافحص المركبة.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-16',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-16-emergency-braking.jpg',
    text: {
      en: 'What is the correct way to brake in an emergency on a dry road?',
      nl: 'Wat is de juiste manier om in noodgevallen te remmen op een droog wegdek?',
      ar: 'ما الطريقة الصحيحة للكبح في الطوارئ على طريق جاف؟',
    },
    options: [
      {
        id: 'q-vh-16o1',
        text: {
          en: 'Pump the brakes gently',
          nl: 'Zachtjes pompend remmen',
          ar: 'الكبح بالضغط المتكرر برفق',
        },
      },
      {
        id: 'q-vh-16o2',
        text: {
          en: 'Apply the brakes firmly; if the vehicle has ABS, keep firm pressure; if not, you may need to pump to avoid locking',
          nl: 'Vast remmen; bij ABS stevige druk houden; zonder ABS mogelijk pompen om blokkeren te voorkomen',
          ar: 'الضغط بثبات على الفرامل؛ إن وجد ABS فاثبت الضغط؛ وإلا قد تحتاج للضغط المتكرر لتجنب انغلاق العجلات',
        },
      },
      {
        id: 'q-vh-16o3',
        text: {
          en: 'Use the handbrake only',
          nl: 'Alleen de handrem gebruiken',
          ar: 'استخدام فرملة اليد فقط',
        },
      },
    ],
    correctAnswerId: 'q-vh-16o2',
    explanation: {
      en: 'Apply the brakes firmly. With ABS, keep firm pressure and steer. Without ABS, you may need to pump the brakes to avoid locking the wheels.',
      nl: 'Rem vast. Met ABS stevige druk houden en sturen. Zonder ABS kunt u mogelijk pompend remmen om het blokkeren van de wielen te voorkomen.',
      ar: 'اضغط الفرامل بثبات. مع ABS أبق الضغط ووجه. بدون ABS قد تحتاج للكبح المتقطع لتجنب انغلاق العجلات.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-17',
    text: {
      en: 'What should you do if your windscreen fogs up on the inside?',
      nl: 'Wat moet u doen als uw voorruit van binnen beslaat?',
      ar: 'ماذا تفعل إذا تعتم الزجاج الأمامي من الداخل؟',
    },
    options: [
      {
        id: 'q-vh-17o1',
        text: {
          en: 'Wipe it with your hand',
          nl: 'Het met uw hand afvegen',
          ar: 'مسحه باليد',
        },
      },
      {
        id: 'q-vh-17o2',
        text: {
          en: 'Use the demister and open a window slightly if needed',
          nl: 'Ontwaseming gebruiken en indien nodig een raam een beetje openzetten',
          ar: 'استخدام مزيل بخار الزجاج وفتح النافذة قليلا عند الحاجة',
        },
      },
      {
        id: 'q-vh-17o3',
        text: {
          en: 'Speed up to clear it',
          nl: 'Versnellen om het te laten verdwijnen',
          ar: 'زيادة السرعة لتصفيته',
        },
      },
    ],
    correctAnswerId: 'q-vh-17o2',
    explanation: {
      en: 'Use the windscreen demister (heater and fan). Opening a window slightly can help clear moisture. Do not drive until you can see clearly.',
      nl: 'Gebruik de voorruitontwaseming (verwarming en ventilator). Een raam een beetje openzetten kan helpen. Rijd niet voordat u goed kunt zien.',
      ar: 'استخدم مزيل بخار الزجاج (التدفئة والمروحة). فتح النافذة قليلا يساعد على تقليل الرطوبة. لا تقد حتى ترى بوضوح.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-18',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-18-strong-wind.jpg',
    text: {
      en: 'When driving in strong wind, what should you do?',
      nl: 'Wat moet u doen bij rijden bij harde wind?',
      ar: 'عند القيادة في رياح قوية، ماذا تفعل؟',
    },
    options: [
      {
        id: 'q-vh-18o1',
        text: {
          en: 'Speed up to stay stable',
          nl: 'Versnellen om stabiel te blijven',
          ar: 'زيادة السرعة للاستقرار',
        },
      },
      {
        id: 'q-vh-18o2',
        text: {
          en: 'Slow down; hold the steering firmly; be extra careful when passing high-sided vehicles or on exposed roads',
          nl: 'Vertragen; het stuur stevig vasthouden; extra voorzichtig bij het inhalen van hoge voertuigen of op open wegen',
          ar: 'الإبطاء؛ إمساك المقود بثبات؛ الحذر الشديد عند تجاوز مركبات عالية أو على طرق مكشوفة',
        },
      },
      {
        id: 'q-vh-18o3',
        text: {
          en: 'Use the hazard lights',
          nl: 'Waarschuwingslichten gebruiken',
          ar: 'استخدام أضواء التحذير',
        },
      },
    ],
    correctAnswerId: 'q-vh-18o2',
    explanation: {
      en: 'Strong wind can push the vehicle. Slow down, hold the steering firmly, and be careful when passing lorries or on bridges and open roads.',
      nl: 'Harde wind kan het voertuig duwen. Vertraag, houd het stuur stevig vast en wees voorzichtig bij vrachtwagens of op bruggen en open wegen.',
      ar: 'الرياح القوية قد تدفع المركبة. أبطئ وأمسك المقود بثبات وكن حذرا عند تجاوز الشاحنات أو على الجسور والطرق المفتوحة.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-19',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-19-puncture-emergency.jpg',
    text: {
      en: 'What should you do if you have a puncture while driving?',
      nl: 'Wat moet u doen als u een lekke band krijgt tijdens het rijden?',
      ar: 'ماذا تفعل إذا انثقب إطار أثناء القيادة؟',
    },
    options: [
      {
        id: 'q-vh-19o1',
        text: {
          en: 'Brake hard and stop immediately',
          nl: 'Hard remmen en onmiddellijk stoppen',
          ar: 'الكبح بقوة والتوقف فورا',
        },
      },
      {
        id: 'q-vh-19o2',
        text: {
          en: 'Hold the steering firmly; ease off the accelerator; pull off the road when safe',
          nl: 'Het stuur stevig vasthouden; gas loslaten; de weg verlaten wanneer het veilig is',
          ar: 'إمساك المقود بثبات؛ خفف الوقود؛ الانسحاب إلى جانب الطريق عند الأمان',
        },
      },
      {
        id: 'q-vh-19o3',
        text: {
          en: 'Accelerate to the nearest garage',
          nl: 'Versnellen naar de dichtstbijzijnde garage',
          ar: 'زيادة السرعة إلى أقرب ورشة',
        },
      },
    ],
    correctAnswerId: 'q-vh-19o2',
    explanation: {
      en: 'Hold the steering wheel firmly. Ease off the accelerator. Do not brake sharply. Pull off the road when it is safe to do so.',
      nl: 'Houd het stuur stevig vast. Laat het gas los. Rem niet scherp. Verlaat de weg wanneer het veilig kan.',
      ar: 'أمسك المقود بثبات. خفف الوقود. لا تكبح بشدة. انسحب إلى جانب الطريق عندما يكون ذلك آمنا.',
    },
    subject: 'Vehicle Handling',
  },
  {
    id: 'q-vh-20',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/vehicle-handling/q-vh-20-abs-indicator.jpg',
    text: {
      en: 'What does ABS (Anti-lock Braking System) allow you to do when braking hard?',
      nl: 'Wat stelt ABS (Anti-lock Braking System) u in staat te doen bij hard remmen?',
      ar: 'ماذا يتيح لك نظام منع انغلاق المكابح (ABS) عند الكبح الشديد؟',
    },
    options: [
      {
        id: 'q-vh-20o1',
        text: {
          en: 'Stop in a shorter distance on all surfaces',
          nl: 'Op alle ondergronden in kortere afstand stoppen',
          ar: 'التوقف في مسافة أقصر على جميع الأسطح',
        },
      },
      {
        id: 'q-vh-20o2',
        text: {
          en: 'Brake hard and still steer; the wheels are prevented from locking',
          nl: 'Hard remmen en toch sturen; de wielen worden tegen blokkeren beschermd',
          ar: 'الكبح بقوة مع الاستمرار في التوجيه؛ يمنع انغلاق العجلات',
        },
      },
      {
        id: 'q-vh-20o3',
        text: {
          en: 'Brake without using the pedal',
          nl: 'Remmen zonder het pedaal te gebruiken',
          ar: 'الكبح دون استخدام الدواسة',
        },
      },
    ],
    correctAnswerId: 'q-vh-20o2',
    explanation: {
      en: 'ABS prevents the wheels from locking under heavy braking so you can steer. Apply firm pressure and steer; do not pump the brakes.',
      nl: 'ABS voorkomt dat de wielen bij zwaar remmen blokkeren, zodat u kunt sturen. Houd stevige druk en stuur; pompend remmen is niet nodig.',
      ar: 'يمنع ABS انغلاق العجلات عند الكبح الشديد لتتمكن من التوجيه. اضغط بثبات ووجه؛ لا تكبح بالضغط المتكرر.',
    },
    subject: 'Vehicle Handling',
  },
];
